import { useState, useEffect } from "react";
import { CalendlyButton } from "@/components/landing/CalendlyButton";
import { SITE } from "@/lib/siteConfig";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-warm-neutral/85 backdrop-blur-md border-b border-navy-900/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="container-page flex items-center justify-between h-20">
        {/* LOGO PLACEHOLDER — replace /public/brand/logo-placeholder.svg with the real logo */}
        <a
          href="#top"
          data-testid="header-logo"
          aria-label={`${SITE.shortName} — home`}
          className="flex flex-col leading-none"
        >
          <span
            className={`font-heading text-2xl md:text-[1.7rem] font-semibold tracking-tight transition-colors duration-500 ${
              scrolled ? "text-navy-900" : "text-warm-neutral"
            }`}
          >
            Brown &amp; Associates
          </span>
          <span
            className={`font-body text-[0.6rem] uppercase tracking-[0.32em] mt-1 transition-colors duration-500 ${
              scrolled ? "text-muted-foreground" : "text-warm-accent"
            }`}
          >
            Bookkeeping &middot; Manchester, NH
          </span>
        </a>

        <CalendlyButton
          testId="header-cta-button"
          variant="dark"
          size="md"
          showIcon={false}
        >
          Schedule a Free Consultation
        </CalendlyButton>
      </div>
    </header>
  );
};

export default Header;
